import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'
import { getAvailableInsuranceBenefits } from 'luxPlus/selectors/benefits/insurance'

function useLuxPlusInsuranceAvailableCopy() {
  const intl = useIntl()
  const view = useAppSelector(getAvailableInsuranceBenefits)
  if (view.isAvailable && !!view.totalMemberMaxSavings) {
    return intl.formatMessage(
      {
        id: 'uWAP0v9lJZBUEdmGsmW4',
        defaultMessage: 'Save up to {discountPercentage}% on travel protection at checkout',
      },
      { discountPercentage: view.luxPlusDiscountPercentage },
    )
  }
}

export default useLuxPlusInsuranceAvailableCopy
